import React, { useState, useContext } from "react";
import { Redirect } from "react-router-dom";

import AuthContext from "../contexts/auth/Context";
import "./SignIn.css";

const SignIn = props => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const authContext = useContext(AuthContext);
  const { loginUser, isLoggedIn } = authContext;

  const inputChangeHandler = e => {
    switch (e.target.type) {
      case "email":
        setEmail(e.target.value);
        break;
      case "password":
        setPassword(e.target.value);
        break;
      default:
        console.log(e.target.value);
    }
  };

  const handleLogin = e => {
    e.preventDefault();
    console.log("Form Submission");
    loginUser(email, password);
  };

  if (
    isLoggedIn &&
    props.location.state &&
    props.location.state.from.pathname.indexOf("questionnaire") !== -1
  ) {
    return <Redirect to={props.location.state.from.pathname} />;
  } else if (isLoggedIn) {
    return <Redirect to="/dashboard" />;
  } else {
    return (
      <div className="relative sign-in w-screen h-screen">
        <hr className="border" />
        <main className="w-screen h-auto mb-64">
          <div className="xl:w-6/12 xl:mt-64 xl:px-16">
            <div className="text-center mt-6 tracking-widest text-2xl font-medium xl:text-3xl xl:font-bold">
              LOGIN
            </div>
            <form className="flex flex-col xl:text-xl" onSubmit={handleLogin}>
              <div className="relative mt-6 flex justify-center">
                <label
                  className="absolute inset-y-0 flex items-center login__label text-gray-800"
                  htmlFor="email"
                >
                  {email.length > 0 ? "" : "Email"}
                </label>
                <input
                  className="py-2 px-4 w-11/12 rounded-lg border border-gray-600 shadow xl:py-3 xl:px-6"
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onChange={inputChangeHandler}
                />
              </div>
              <div className="relative mt-4 flex justify-center">
                <label
                  className="absolute inset-y-0 flex items-center login__label text-gray-800"
                  htmlFor="password"
                >
                  {password.length > 0 ? "" : "Password"}
                </label>
                <input
                  className="py-2 px-4 w-11/12 rounded-lg border border-gray-600 shadow xl:py-3 xl:px-6"
                  type="password"
                  name="password"
                  id="password"
                  value={password}
                  onChange={inputChangeHandler}
                />
              </div>
              <div className="mt-6 flex justify-center">
                <button
                  className="bg-brand-green-gradient rounded-full text-white px-6 py-2 font-black tracking-widest shadow-md"
                  type="submit"
                >
                  LOGIN
                </button>
              </div>
            </form>
          </div>
          <p className="w-8/12 mx-auto mt-6">Forgot Password. Click Here</p>
        </main>
      </div>
    );
  }
};

export default SignIn;
